export const INSCRICAO_PGFN_COBRANCA = [
  {
    "numeroInscricao": "7020401561774",
    "situacao": "ATIVA AJUIZADA",
    "niEstabelecimento": "00000000000191",
    "niDevedorPrincipal": "33126079000150",
    "tipoDevedorPrincipal": "1",
    "numeroProcesso": "18471002849200398",
    "inTamanhoProcesso": "2",
    "tipoDevedor": "2",
    "dataInscricao": "2004-09-28",
    "dataAjuizamento": "2005-01-31",
    "orgaoResponsavel": "SEGUNDA REGIAO",
    "codigoReceita": "3551",
    "nomeTributo": "IRPJ",
    "dataAnalise": null
  },
  {
    "numeroInscricao": "7020601325241",
    "situacao": "ATIVA AJUIZADA",
    "niEstabelecimento": "00000000000191",
    "niDevedorPrincipal": "68736289000145",
    "tipoDevedorPrincipal": "1",
    "numeroProcesso": "10768531963200636",
    "inTamanhoProcesso": "2",
    "tipoDevedor": "2",
    "dataInscricao": "2006-07-20",
    "dataAjuizamento": "2006-12-18",
    "orgaoResponsavel": "SEGUNDA REGIAO",
    "codigoReceita": "3551",
    "nomeTributo": "IRPJ",
    "dataAnalise": null
  },
  {
    "numeroInscricao": "7020800097796",
    "situacao": "ATIVA AJUIZADA",
    "niEstabelecimento": "00000000000191",
    "niDevedorPrincipal": "00684660000139",
    "tipoDevedorPrincipal": "1",
    "numeroProcesso": "10768500067200897",
    "inTamanhoProcesso": "2",
    "tipoDevedor": "2",
    "dataInscricao": "2008-07-24",
    "dataAjuizamento": "2008-09-22",
    "orgaoResponsavel": "SEGUNDA REGIAO",
    "codigoReceita": "3551",
    "nomeTributo": "IRPJ",
    "dataAnalise": null
  },
  {
    "numeroInscricao": "7021300957115",
    "situacao": "ATIVA COM AJUIZAMENTO A SER PROSSEGUIDO",
    "niEstabelecimento": "00000000000191",
    "niDevedorPrincipal": "42219998000160",
    "tipoDevedorPrincipal": "1",
    "numeroProcesso": "12448730683201114",
    "inTamanhoProcesso": "2",
    "tipoDevedor": "2",
    "dataInscricao": "2013-11-22",
    "dataAjuizamento": null,
    "orgaoResponsavel": "SEGUNDA REGIAO",
    "codigoReceita": "3551",
    "nomeTributo": "IRPJ",
    "dataAnalise": null
  },
  {
    "numeroInscricao": "7030300006284",
    "situacao": "ATIVA AJUIZADA",
    "niEstabelecimento": "00000000000191",
    "niDevedorPrincipal": "29978806000211",
    "tipoDevedorPrincipal": "1",
    "numeroProcesso": "10768511713200256",
    "inTamanhoProcesso": "2",
    "tipoDevedor": "2",
    "dataInscricao": "2003-01-17",
    "dataAjuizamento": "2003-08-25",
    "orgaoResponsavel": "SEGUNDA REGIAO",
    "codigoReceita": "3578",
    "nomeTributo": "IPI",
    "dataAnalise": null
  },
  {
    "numeroInscricao": "7041200227934",
    "situacao": "ATIVA AJUIZADA",
    "niEstabelecimento": "00000000000191",
    "niDevedorPrincipal": "72509821000169",
    "tipoDevedorPrincipal": "1",
    "numeroProcesso": "18208123013200851",
    "inTamanhoProcesso": "2",
    "tipoDevedor": "2",
    "dataInscricao": "2012-03-29",
    "dataAjuizamento": "2012-04-23",
    "orgaoResponsavel": "SEGUNDA REGIAO",
    "codigoReceita": "8822",
    "nomeTributo": "SIMPLES",
    "dataAnalise": null
  },
  {
    "numeroInscricao": "7060403763314",
    "situacao": "ATIVA AJUIZADA",
    "niEstabelecimento": "00000000000191",
    "niDevedorPrincipal": "33126079000150",
    "tipoDevedorPrincipal": "1",
    "numeroProcesso": "18471002849200398",
    "inTamanhoProcesso": "2",
    "tipoDevedor": "2",
    "dataInscricao": "2004-09-28",
    "dataAjuizamento": "2005-01-31",
    "orgaoResponsavel": "SEGUNDA REGIAO",
    "codigoReceita": "1804",
    "nomeTributo": "CONTRIBUICAO SOCIAL",
    "dataAnalise": null
  },
  {
    "numeroInscricao": "7060603954393",
    "situacao": "ATIVA AJUIZADA",
    "niEstabelecimento": "00000000000191",
    "niDevedorPrincipal": "68736289000145",
    "tipoDevedorPrincipal": "1",
    "numeroProcesso": "10768531964200681",
    "inTamanhoProcesso": "2",
    "tipoDevedor": "2",
    "dataInscricao": "2006-07-20",
    "dataAjuizamento": "2006-12-18",
    "orgaoResponsavel": "SEGUNDA REGIAO",
    "codigoReceita": "4493",
    "nomeTributo": "COFINS",
    "dataAnalise": null
  },
  {
    "numeroInscricao": "7060603954474",
    "situacao": "ATIVA AJUIZADA",
    "niEstabelecimento": "00000000000191",
    "niDevedorPrincipal": "68736289000145",
    "tipoDevedorPrincipal": "1",
    "numeroProcesso": "10768531966200670",
    "inTamanhoProcesso": "2",
    "tipoDevedor": "2",
    "dataInscricao": "2006-07-20",
    "dataAjuizamento": "2006-12-18",
    "orgaoResponsavel": "SEGUNDA REGIAO",
    "codigoReceita": "1804",
    "nomeTributo": "CONTRIBUICAO SOCIAL",
    "dataAnalise": null
  },
  {
    "numeroInscricao": "7060701299527",
    "situacao": "ATIVA AJUIZADA",
    "niEstabelecimento": "00000000000191",
    "niDevedorPrincipal": "29708492000156",
    "tipoDevedorPrincipal": "1",
    "numeroProcesso": "18471000842200331",
    "inTamanhoProcesso": "2",
    "tipoDevedor": "2",
    "dataInscricao": "2007-05-28",
    "dataAjuizamento": "2007-08-27",
    "orgaoResponsavel": "SEGUNDA REGIAO",
    "codigoReceita": "4493",
    "nomeTributo": "COFINS",
    "dataAnalise": null
  },
  {
    "numeroInscricao": "7060800242906",
    "situacao": "ATIVA AJUIZADA",
    "niEstabelecimento": "00000000000191",
    "niDevedorPrincipal": "00684660000139",
    "tipoDevedorPrincipal": "1",
    "numeroProcesso": "10768500068200831",
    "inTamanhoProcesso": "2",
    "tipoDevedor": "2",
    "dataInscricao": "2008-07-24",
    "dataAjuizamento": "2008-09-22",
    "orgaoResponsavel": "SEGUNDA REGIAO",
    "codigoReceita": "4493",
    "nomeTributo": "COFINS",
    "dataAnalise": null
  },
  {
    "numeroInscricao": "7060800243040",
    "situacao": "ATIVA AJUIZADA",
    "niEstabelecimento": "00000000000191",
    "niDevedorPrincipal": "00684660000139",
    "tipoDevedorPrincipal": "1",
    "numeroProcesso": "10768500070200819",
    "inTamanhoProcesso": "2",
    "tipoDevedor": "2",
    "dataInscricao": "2008-07-24",
    "dataAjuizamento": "2008-09-22",
    "orgaoResponsavel": "SEGUNDA REGIAO",
    "codigoReceita": "1804",
    "nomeTributo": "CONTRIBUICAO SOCIAL",
    "dataAnalise": null
  },
  {
    "numeroInscricao": "7061302109390",
    "situacao": "ATIVA AJUIZADA",
    "niEstabelecimento": "00000000000191",
    "niDevedorPrincipal": "42219998000160",
    "tipoDevedorPrincipal": "1",
    "numeroProcesso": "12448730683201114",
    "inTamanhoProcesso": "2",
    "tipoDevedor": "2",
    "dataInscricao": "2013-11-22",
    "dataAjuizamento": null,
    "orgaoResponsavel": "SEGUNDA REGIAO",
    "codigoReceita": "1804",
    "nomeTributo": "CONTRIBUICAO SOCIAL",
    "dataAnalise": null
  },
  {
    "numeroInscricao": "7061302109471",
    "situacao": "ATIVA AJUIZADA",
    "niEstabelecimento": "00000000000191",
    "niDevedorPrincipal": "42219998000160",
    "tipoDevedorPrincipal": "1",
    "numeroProcesso": "12448730683201114",
    "inTamanhoProcesso": "2",
    "tipoDevedor": "2",
    "dataInscricao": "2013-11-22",
    "dataAjuizamento": null,
    "orgaoResponsavel": "SEGUNDA REGIAO",
    "codigoReceita": "4493",
    "nomeTributo": "COFINS",
    "dataAnalise": null
  },
  {
    "numeroInscricao": "7070600668834",
    "situacao": "ATIVA AJUIZADA",
    "niEstabelecimento": "00000000000191",
    "niDevedorPrincipal": "68736289000145",
    "tipoDevedorPrincipal": "1",
    "numeroProcesso": "10768531965200625",
    "inTamanhoProcesso": "2",
    "tipoDevedor": "2",
    "dataInscricao": "2006-07-20",
    "dataAjuizamento": "2006-12-18",
    "orgaoResponsavel": "SEGUNDA REGIAO",
    "codigoReceita": "0810",
    "nomeTributo": "PIS",
    "dataAnalise": null
  },
  {
    "numeroInscricao": "7070700120695",
    "situacao": "ATIVA AJUIZADA",
    "niEstabelecimento": "00000000000191",
    "niDevedorPrincipal": "29708492000156",
    "tipoDevedorPrincipal": "1",
    "numeroProcesso": "18471000841200397",
    "inTamanhoProcesso": "2",
    "tipoDevedor": "2",
    "dataInscricao": "2007-05-28",
    "dataAjuizamento": "2007-08-27",
    "orgaoResponsavel": "SEGUNDA REGIAO",
    "codigoReceita": "0810",
    "nomeTributo": "PIS",
    "dataAnalise": null
  },
  {
    "numeroInscricao": "7070800065092",
    "situacao": "ATIVA AJUIZADA",
    "niEstabelecimento": "00000000000191",
    "niDevedorPrincipal": "00684660000139",
    "tipoDevedorPrincipal": "1",
    "numeroProcesso": "10768500069200886",
    "inTamanhoProcesso": "2",
    "tipoDevedor": "2",
    "dataInscricao": "2008-07-24",
    "dataAjuizamento": "2008-09-22",
    "orgaoResponsavel": "SEGUNDA REGIAO",
    "codigoReceita": "0810",
    "nomeTributo": "PIS",
    "dataAnalise": null
  },
  {
    "numeroInscricao": "7071300642641",
    "situacao": "ATIVA AJUIZADA",
    "niEstabelecimento": "00000000000191",
    "niDevedorPrincipal": "42219998000160",
    "tipoDevedorPrincipal": "1",
    "numeroProcesso": "12448730683201114",
    "inTamanhoProcesso": "2",
    "tipoDevedor": "2",
    "dataInscricao": "2013-11-22",
    "dataAjuizamento": null,
    "orgaoResponsavel": "SEGUNDA REGIAO",
    "codigoReceita": "0810",
    "nomeTributo": "PIS",
    "dataAnalise": null
  }
];


export const INSCRICAO_PGFN_EXIGIBILIDADE = [
  {
    "numeroInscricao": "7020600656228",
    "situacao": "ATIVA AJUIZADA NEGOCIADA NO SISPAR",
    "niEstabelecimento": "00000000000191",
    "niDevedorPrincipal": "02754754000162",
    "tipoDevedorPrincipal": "1",
    "numeroProcesso": "10768512729200618",
    "inTamanhoProcesso": "2",
    "tipoDevedor": "2",
    "dataInscricao": "2006-07-20",
    "dataAjuizamento": "2006-12-18",
    "orgaoResponsavel": "SEGUNDA REGIAO",
    "codigoReceita": "3551",
    "nomeTributo": "IRPJ",
    "dataAnalise": null
  },
  {
    "numeroInscricao": "7060202424377",
    "situacao": "ATIVA AJUIZADA COM EXIGIBILIDADE DO CREDITO SUSPENSA-DECISAO JUDI",
    "niEstabelecimento": "00000000000191",
    "niDevedorPrincipal": "01824808000156",
    "tipoDevedorPrincipal": "1",
    "numeroProcesso": "10730208514200291",
    "inTamanhoProcesso": "2",
    "tipoDevedor": "2",
    "dataInscricao": "2002-09-27",
    "dataAjuizamento": "2002-11-25",
    "orgaoResponsavel": "SEGUNDA REGIAO",
    "codigoReceita": "4493",
    "nomeTributo": "COFINS",
    "dataAnalise": "2021-01-22"
  },
  {
    "numeroInscricao": "7060602985813",
    "situacao": "ATIVA AJUIZADA NEGOCIADA NO SISPAR",
    "niEstabelecimento": "00000000000191",
    "niDevedorPrincipal": "02754754000162",
    "tipoDevedorPrincipal": "1",
    "numeroProcesso": "10768512730200634",
    "inTamanhoProcesso": "2",
    "tipoDevedor": "2",
    "dataInscricao": "2006-07-20",
    "dataAjuizamento": "2006-12-18",
    "orgaoResponsavel": "SEGUNDA REGIAO",
    "codigoReceita": "4493",
    "nomeTributo": "COFINS",
    "dataAnalise": null
  },
  {
    "numeroInscricao": "7060602985902",
    "situacao": "ATIVA AJUIZADA NEGOCIADA NO SISPAR",
    "niEstabelecimento": "00000000000191",
    "niDevedorPrincipal": "02754754000162",
    "tipoDevedorPrincipal": "1",
    "numeroProcesso": "10768512732200623",
    "inTamanhoProcesso": "2",
    "tipoDevedor": "2",
    "dataInscricao": "2006-07-20",
    "dataAjuizamento": "2006-12-18",
    "orgaoResponsavel": "SEGUNDA REGIAO",
    "codigoReceita": "1804",
    "nomeTributo": "CONTRIBUICAO SOCIAL",
    "dataAnalise": null
  },
  {
    "numeroInscricao": "7060605577066",
    "situacao": "ATIVA AJUIZADA NEGOCIADA NO SISPAR",
    "niEstabelecimento": "00000000000191",
    "niDevedorPrincipal": "39114723000157",
    "tipoDevedorPrincipal": "1",
    "numeroProcesso": "10768534589200621",
    "inTamanhoProcesso": "2",
    "tipoDevedor": "2",
    "dataInscricao": "2006-11-30",
    "dataAjuizamento": "2006-12-04",
    "orgaoResponsavel": "SEGUNDA REGIAO",
    "codigoReceita": "1804",
    "nomeTributo": "CONTRIBUICAO SOCIAL",
    "dataAnalise": null
  },
  {
    "numeroInscricao": "7070600410152",
    "situacao": "ATIVA AJUIZADA NEGOCIADA NO SISPAR",
    "niEstabelecimento": "00000000000191",
    "niDevedorPrincipal": "02754754000162",
    "tipoDevedorPrincipal": "1",
    "numeroProcesso": "10768512731200689",
    "inTamanhoProcesso": "2",
    "tipoDevedor": "2",
    "dataInscricao": "2006-07-20",
    "dataAjuizamento": "2006-12-18",
    "orgaoResponsavel": "SEGUNDA REGIAO",
    "codigoReceita": "0810",
    "nomeTributo": "PIS",
    "dataAnalise": null
  },
  {
    "numeroInscricao": "7070601128698",
    "situacao": "ATIVA AJUIZADA NEGOCIADA NO SISPAR",
    "niEstabelecimento": "00000000000191",
    "niDevedorPrincipal": "39114723000157",
    "tipoDevedorPrincipal": "1",
    "numeroProcesso": "10768534588200686",
    "inTamanhoProcesso": "2",
    "tipoDevedor": "2",
    "dataInscricao": "2006-11-30",
    "dataAjuizamento": "2006-12-04",
    "orgaoResponsavel": "SEGUNDA REGIAO",
    "codigoReceita": "0810",
    "nomeTributo": "PIS",
    "dataAnalise": null
  },
  {
    "numeroInscricao": "7080800041212",
    "situacao": "ATIVA AJUIZADA PARCELADA LEI 12996/14",
    "niEstabelecimento": "00000000000191",
    "niDevedorPrincipal": "00011966858787",
    "tipoDevedorPrincipal": "2",
    "numeroProcesso": "10073720162200742",
    "inTamanhoProcesso": "2",
    "tipoDevedor": "2",
    "dataInscricao": "2008-06-09",
    "dataAjuizamento": "2008-08-18",
    "orgaoResponsavel": "SEGUNDA REGIAO",
    "codigoReceita": "8900",
    "nomeTributo": "ITR EX 97 E POSTERIO",
    "dataAnalise": null
  }
];
